import {
  removeSpinner,
} from "./errors.js";


/**
 * directly send empty VAT validation AJAX request.
 * Is silent call, used to make shure to reset vat state in backend.
 * Errors response are not shown to user, he sees only js validation error.
* @param {boolean} precheck resulted by js validator.
*/
export async function callForEmptyVat() {

    console.warn('FicooAjax: Using fake AJAX call for empty VAT validation.');

    try {
        return true;

    } catch (error) {

        return false;

    } finally {
        removeSpinner("vat");
    }

}

/**
 * directly send valid VAT validation AJAX request.
 * @param {string} vatNumber
 * @param {string} countryCode
 * @returns {Promise<boolean>} true if vat is valid, false if not valid or error.
 */
export async function callForValidVat() {


    console.warn('FicooAjax: Using fake AJAX call for valid VAT validation.');

    try {

        return true;

    } catch (error) {
        return false;

    } finally {
        removeSpinner("vat");
    }
}

/**
 * directly send invalid VAT validation AJAX request.
 * Is silent call, used to make shure to reset vat state in backend.
 * Errors response are not shown to user, he sees only js validation error.
 * @param {boolean} precheck resulted by js validator.
 */
export async function callForInvalidVat() {

    console.warn('FicooAjax: Using fake AJAX call for invalid VAT validation.');

    try {

        return true;
    } catch (error) {
        return false;

    } finally {
        removeSpinner("vat");
    }

}

